import { AxiosRequestConfig } from 'axios'

export interface FoodPreferenceAnalysisByLevelDetailedParams {
  startDate: string
  endDate: string
  storeId?: number
  questionId?: number
}

export interface UserPollQuestion {
  id: number
  question: string
  order: number
  active: boolean
  defaultDashboard: boolean
  answered: number
  detail: Array<{
    id: number
    userPollId: number
    tag: number
    answer: string
    active: boolean
    iconId: string | null
    createdAt: string
    updatedAt: string
    deletedAt: string | null
  }>
}

export interface UserPollQuestionsResponse {
  userPolls: UserPollQuestion[]
}

export interface FoodPreferenceData {
  level: number
  code: string
  name: string
  value: number
  color: string
}

export const getUserPollQuestions = (): AxiosRequestConfig => ({
  url: '/user-poll',
  method: 'GET',
})

export const getFoodPreferenceAnalysisByLevelDetailed = (
  params: FoodPreferenceAnalysisByLevelDetailedParams,
): AxiosRequestConfig => ({
  url: '/dashboard/food-preference-analysis-by-level-detailed',
  method: 'GET',
  params,
})
